import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Insights } from './components';

const Insights = lazy(()=> import(/* webpackChunkName: "Insights" */ './components/Insights'))

const routes = () => (
  <PrivateRoute exact path="/insights" component={Insights} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/insights/Insights/routes.js